var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAc = function SvgAc(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg5779",
    width: 24,
    height: 32,
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0 -1020.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polygon3275",
    fill: "currentColor",
    d: "M204.56 3094.6h-18.5l-5 26.3h9.25l-4.85 21.7h3.08l19.51-30h-10.07z",
    transform: "translate(-113.71 -1042.7)scale(.66667)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAc);
export default ForwardRef;